import autobind from 'autobind-decorator';
import * as React from 'react';
import { FormProps, reduxForm } from 'redux-form';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import AppTitleUpdater from 'login-components/Common/AppTitleUpdater';
import FormDialogFooter from 'login-components/Common/Form/FormDialog/FormDialogFooter';
import InputMap from 'login-components/Common/Inputs/InputMap';
import OldFormBody from '../FormComponents/OldFormBody';
import * as formUtils from 'login-utils/formUtils';
import './login-form.scss';

const inputs: FormInput[] = [
  {
    ...InputMap.EmailInput,
    name: 'username',
    identifier: 'username',
  },
  {
    ...InputMap.PasswordInput,
    name: 'password',
    identifier: 'password',
  },
];

const FORM_ERROR_ID = 'LoginForm-formError';

export interface OldLoginFormProps extends FormProps<any, any, any> {
  successMsg?: string | false | null;
  errorMsg?: string;
}

@autobind
export class OldLoginForm extends React.Component<OldLoginFormProps, {}> {
  private loginFormRef = React.createRef<HTMLFormElement>();

  submitLogin() {
    formUtils.submitForm(this.loginFormRef.current!);
  }

  render() {
    const actionText = 'Sign In';
    const { handleSubmit, errorMsg, successMsg, submitting } = this.props;
    return (
      <AppTitleUpdater text="Sign in to your account">
        <form
          ref={this.loginFormRef}
          action="/api/public/login"
          method="POST"
          className="LoginForm"
          id="it-LoginForm"
          noValidate
          onSubmit={handleSubmit!(this.submitLogin)}
        >
          <OldFormBody
            inputs={inputs}
            errorId={FORM_ERROR_ID}
            errorMsg={errorMsg}
            successMsg={successMsg}
            showForgotPassword={true}
          />
          <FormDialogFooter>
            <PrimaryButton buttonId="it-LoginSubmit" disabled={submitting} text={actionText} />
          </FormDialogFooter>
        </form>
      </AppTitleUpdater>
    );
  }
}

const ConnectedLoginForm = reduxForm({
  form: 'login',
  validate: values => formUtils.validate(inputs, values),
  onSubmitFail: syncErrors => {
    return formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID);
  },
})(OldLoginForm);

export default ConnectedLoginForm;
